var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "index-container" }, [
      _c("div", { staticStyle: { padding: "20px" }, attrs: { id: "pdf" } }, [
        _vm._v(" 欢迎来到回天商业圈平台管理系统 ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }